<template>
  <div v-if="privilegios" class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Panel Principal',
            path: '/dashboard',
            icon: 'ni ni-tv-2 text-primary',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="privilegios == 'SU' || privilegios == 'C'"
          :link="{
            name: 'Gestión',
            path: '/gestion_grupos',
            icon: 'ni ni-planet text-blue',
          }"
        >
          <sidebar-item
            :link="{
              name: 'Gestion Catequesis',
              path: '/gestion_grupos',
              icon: 'ni ni-planet text-blue',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Gestion Catecumenos',
              path: '/gestionCatecumenos',
              icon: 'ni ni-planet text-blue',
            }"
          />
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'User Profile',
            path: '/profile',
            icon: 'ni ni-single-02 text-yellow',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="privilegios == 'SU'"
          :link="{
            name: 'Gestión de Usuarios',
            path: '/gestionUsuarios',
            icon: 'ni ni-circle-08 text-green',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="privilegios == 'SU'"
          :link="{
            name: 'Register',
            path: '/register',
            icon: 'ni ni-circle-08 text-pink',
          }"
        >
        </sidebar-item>
      </template>

      <template slot="links-after"> </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>
  </div>
</template>

<script>
function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { Modal } from "@/components";
import DashboardNavbar from "./DashboardNavbar.vue";
import { FadeTransition } from "vue2-transitions";
import axios from "@/directives/axios.js";

import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  data() {
    return {
    };
  },
  components: {
    DashboardNavbar,
    FadeTransition,
    Modal,
  },
  computed: {
    privilegios(){
      if (this.$store.getters.getTipoPrivilegiosUsuario == undefined) {
        this.$store.dispatch("cargaPrivilegiosUsuario");
        loader.open();
        return null;
      } else {
        loader.close();
        return this.$store.getters.getTipoPrivilegiosUsuario;
      }
    },
  },
  methods: {
    cerrarSesion() {
      axios({
        method: "post",
        url: `/log-out`,
        withCredentials: true,
      })
        .then(() => {
          this.$cookies.remove("catecumen_token");
          this.$router.push({ name: "login" });
          swal.fire({
            title: `Sesión Cerrada Correctamente`,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          });
        })
        .catch((result) => {});
    },
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
  },
  mounted() {
    this.$store.commit("resetValues");
    this.initScrollbar();
  },
};
</script>
<style lang="scss"></style>
